import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent {
  public formPass: FormGroup;
  public hide: boolean = true;

  constructor(private fb: FormBuilder, private router: Router) {}

  ngOnInit() {
    this.formPass = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/),
          ],
        ],

        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/),
          ],
        ],
      },
      {
        validator: this.passwordMatchValidator,
      }
    );
  }

  campoValido(campo: string) {
    console.log(this.formPass.controls[campo].errors);
    return (
      this.formPass.controls[campo].errors &&
      this.formPass.controls[campo].touched
    );
  }
  get f() {
    return this.formPass.controls;
  }

  passwordMatchValidator(g: FormGroup) {
    const password = g.get('password')!.value;
    const confirmPassword = g.get('confirmPassword')!.value;

    return password === confirmPassword ? null : { mismatch: true };
  }
  submit() {
    Swal.fire({
      text: 'Estamos validando tus credenciales',
      icon: 'question',
      

      didOpen: () => {
        Swal.close();
      },

      // didOpen: () => {
      //   Swal.showLoading();
      //   this.authService.login(request).subscribe({
      //     next: (data) => {
      //       this.authService.setToken(data.token);
      //       const pass = this.authService.changePass();
      //       console.log(pass);
      //       if (pass == 'False') {
      //         Swal.fire({
      //           title: 'Bienvenido',
      //           text: 'Para poder ingresar a tu cuenta, primero debes cambiar de contraseña',
      //           icon: 'warning',
      //           confirmButtonText: 'Cambiar Contraseña',
      //         }).then((e) => {
      //           this.router.navigateByUrl('/authentication/change-pass');
      //         });
      //       } else {
      //         Swal.close();
      //         this.router.navigateByUrl('/dashboards/client');
      //       }

      //     },
      //     error: (err) => {
      //       Swal.fire({
      //         title: 'Error',
      //         text: 'El rut y/o la contraseña, son incorrectas',
      //         icon: 'error',
      //       });
      //       this.router.navigate(['/authentication/login']);
      //     },
      //   });
      // },
    });
    this.router.navigateByUrl('/dashboards/client');
  }
}
